import React, { useState, useEffect } from 'react';
import 'semantic-ui-css/semantic.min.css';
import styled from 'styled-components';

import { dependencies } from '../package.json';
import ConfigInput from './components/ConfigInput';
import Results from './components/Results';
const contentful = require('contentful');

const Body = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  margin: 20px 20px;
`;

const client = contentful.createClient({
  space: "5nhfqlmdjvxq",
  accessToken: "6e38086893f9d70ad20b3e964c7f99d72779795b7d17bb2f8a6c8fa84e3376a7",
});

function App() {
  const [configInput, setConfigInput] = useState('');
  const [shouldRefresh, setRefresh] = useState(Date.now());
  const [preDefinedConfig, setDefinedConfig] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    client
      .getEntry('4gkBaVbwoQeA1IagDESW5E')
      .then(entry => setDefinedConfig(entry.fields.mediaKeySystemConfiguration))
      .catch(setError);
  }, []);

  const getConfigInput = data => {
    setError('');
    try {
      setConfigInput(
        data.from === 'definedConfig' ? data.value : JSON.parse(data.value)
      );
      setRefresh(Date.now());
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div className="App">
      <header>
        <h1>Drm Environment Helpers - Canal+</h1>
        <p>
          Using <code>mediaCapabilitiesProber</code> from{' '}
          <span style={{ fontWeight: 'bold', color: 'red' }}>
            rx-player ({dependencies['rx-player']})
          </span>
        </p>
        <hr className="separator" />
      </header>
      <Body>
        <ConfigInput
          getConfigInputState={getConfigInput}
          preDefinedConfig={preDefinedConfig}
        />
        <Results
          configInput={configInput}
          error={error}
          shouldRefresh={shouldRefresh}
        />
      </Body>
    </div>
  );
}

export default App;
